import { apiFetch } from '@m/utils/http';

export const CustomerService = {
  removeUser: ({ userId }: { userId: number }) =>
    apiFetch(`/admin/${userId}`, {
      method: 'DELETE',
    }),
};
